<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'DropDownFormation'
});
</script>
<template>
  <ka-container
    code="drop-down-formation"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <!-- Deroule -->
    <ka-container
      code="deroule"
      :options="{
        click: componentInstance.derouleClick,
        $state: { selected: componentInstance.$estDeplie.value === true }
      }"
      :selected="{ click: componentInstance.derouleClickWhenSelected }">
      <!-- Titre -->
      <ka-container code="titre">
        <ka-text code="h-3">
          <h3 v-html="componentInstance.$titre.value" />
        </ka-text>
      </ka-container>
      <ka-icon
        code="toggle-icon"
        :options="{ $inheritState: { selected: true } }"
        value="i-fa-solid:angle-down" />
    </ka-container>
    <!-- Toggle -->
    <ka-container
      code="toggle"
      :options="{ hidden: componentInstance.$estDeplie.value === true ? false : null }">
      <!-- Container exemples -->
      <ka-container code="container-exemples">
        <ka-list
          code="drop-down-formation-list"
          :options="{
            placeholder: t('dropDownFormation.toggle.containerExemples.dropDownFormationList.placeholder', `No items`),
            debounce: 0,
            entity: `Kapix.Entity.IDropDownFormation`,
            items: componentInstance.$arguments.value
          }"
          :data="componentInstance.$info.dropDownFormationList">
          <template #item="listItemProps">
            <EntitiesDropDownFormationListItem
              :drop-down-formation="listItemProps.item"
              :options="listItemProps.options" />
          </template>
        </ka-list>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { dropDownFormationComponent } from './store'
import EntitiesDropDownFormationListItem from '~/components/Entities/DropDownFormation/ListItem/index.vue'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c13')
const component = dropDownFormationComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  titre?: Nullable<string>
  arguments?: PartialEntities<Kapix.Entity.IDropDownFormation>
  estDeplie?: Nullable<boolean>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  titre: 'Titre',
  arguments: () => [
    { Text: '<ul><li>Appréhender le marché de la recherche en ligne.</li></ul>' },
    { Text: '<ul><li>Appréhender le marché de la recherche en ligne.</li></ul>' },
    { Text: '<ul><li>Appréhender le marché de la recherche en ligne.</li></ul>' }
  ],
  estDeplie: false,
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:titre',
  'update:arguments',
  'update:estDeplie'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    titre: true,
    arguments: true,
    estDeplie: true
  }
})
</script>
